import { gql } from '@apollo/client'

export default gql`
    query ExternalSearchQuery($q: String, $offset: Int, $limit: Int) {
        externalSearch(q: $q, offset: $offset, limit: $limit) {
            total
            edges {
                id
                title
                snippet
                url
            }
        }
    }
`
